import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { getProductFeatureContentHandler } from "../../redux/action/getProductFeatureContentSlice";
import Loader from "../../components/Loder/loader";
import { getGroupProductFeatureContentHandler } from "../../redux/action/getGroupProductFeatureContent";
import { BreadCrum } from "../../common";
import { fileUploadAction } from "../../redux/action/fileUpload";
import GroupDragger from "../Dragger/groupDragger";
import Dragger from "../Dragger/Dragger";
import { removeItem } from "../../common/localStorage";
import { getProductParentRoute } from "./productNavigation";

const HowToAccessMembership = () => {
  const [deleteUploadedFile, setDeleteUploadedFile] = useState("")
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location

  const dispatch = useDispatch()
  const getProductFeatureContentSelector = useSelector((state) => state?.getProductFeatureContentMain)
  const getGroupProductFeatureContent = useSelector((state) => state?.getGroupProductFeatureContent)

  let getFeatureFromGroup = getGroupProductFeatureContent?.data?.data

  useEffect(() => {
    if (state?.fromGroupData?.id) {
      let payload1 = {
        groupProductFeatureId: state?.fromGroupData?.id
      }
      dispatch(getGroupProductFeatureContentHandler(payload1))
    } else if (!state?.fromGroupData) {
      let payload = {
        productId: state?.productId || state?.item?.productId,
        refFeatureId: state?.refFeatureId || state?.item?.refFeatureId
      }
      dispatch(getProductFeatureContentHandler(payload))
    }
  }, [state])

  return (
    <>
      {getProductFeatureContentSelector?.isLoading === true && <Loader loaderTransForm="loaderTransForm" />}
      <div className="rightside">
        <div className="rightcontent">
          <p>
            <strong>Manage Product</strong>
          </p>
          <CustomBreadcrumb
            items={[
              { text: BreadCrum.HOME },
              { text: getFeatureFromGroup?.groupLevelModification ? BreadCrum.GROUPS : BreadCrum.PRODUCTS, onClick: () => { navigate(getFeatureFromGroup?.groupLevelModification ? "/groups" : "/product"); removeItem("productId"); dispatch(fileUploadAction.fileUploadInfoReset()) } },
              {
                text: state?.manageProduct || state?.viewProduct || getFeatureFromGroup?.groupLevelModification ? BreadCrum.MANAGE_PRODUCTS : BreadCrum.ADD_PRODUCT, onClick: () => {
                  const path = getProductParentRoute(state, getFeatureFromGroup);
                  dispatch(fileUploadAction.fileUploadInfoReset())
                  const navigationState = {
                    productId: state?.productId,
                    groupCode: state?.fromGroupData?.groupId
                  };
                  navigate(path, { state: navigationState });
                }
              },
              ...(getFeatureFromGroup?.groupLevelModification && getFeatureFromGroup?.productName ? [{ text: getFeatureFromGroup.productName }] : []),
              { text: BreadCrum.HOW_TO_ACCESS_MEMBERSHIP, active: true },
            ]}
          />

          <div className="table-padding mb-30">
            <div className="headtitle justify-content-start">
              <div className="lineafter">
                <div className="productname">Product Name</div>
                <div className="producttitle">{state?.productData?.productName || getProductFeatureContentSelector?.data?.data?.productName || getGroupProductFeatureContent?.data?.data?.productName}</div>
              </div>
              <p className="mb-0 heedprodct">{state?.item?.featureName|| state?.fromGroupData?.featureName || state?.featureName}</p>
            </div>
          </div>
          {state?.fromGroupData?.id ? (
            <GroupDragger deleteUploadedFile={deleteUploadedFile} setDeleteUploadedFile={setDeleteUploadedFile} state={state} />
          ) : (
            <Dragger deleteUploadedFile={deleteUploadedFile} setDeleteUploadedFile={setDeleteUploadedFile} state={state} />
          )}
        </div>
      </div>
    </>
  );
};

export default HowToAccessMembership;
